import * as yup from 'yup';

const ValidationSchema = yup.object().shape({
  name: yup.string().required('Campo obrigatório').nullable(),
  type: yup.string().oneOf(['INCOME', 'EXPENSE']).required('Campo obrigatório').nullable(),
});

export default ValidationSchema;
